import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "licence-info" }
const _hoisted_2 = {
  key: 0,
  class: "licence-info-text"
}
const _hoisted_3 = {
  key: 0,
  class: "licence-info-alert"
}
const _hoisted_4 = { class: "licence-info__calendar-text" }

import { ElTooltip } from 'element-plus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import Calendar from '@/components/icons/CalendarClock.vue';
import dayjs from '@/utils/dayjs';
import { LabData } from '@/types/LabData';
import { formatDate, isSU } from '@/utils';
import { LicenseState } from '@/router/Laboratories/Laboratory/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'LicenceInfo',
  props: {
    product: {}
  },
  setup(__props: any) {

const { t } = useI18n();
const store = useStore();

const props = __props;

const isAdminOrModerator = computed(() => isSU(store.getters.role));

const formatTime = (seconds: number, isTooltipText: boolean = false): string => {
  if (!seconds) { return ''; }
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  let time = '';

  if (hours && !isTooltipText) {
    time = `${hours} ${t('time.hour')}. `;
  } else {
    time = `<b>${hours}</b> ${t('time.hour')}. `;
  }

  if (minutes && !isTooltipText) {
    time += `${minutes} ${t('time.minute')}.`;
  } else {
    time += `<b>${minutes}</b> ${t('time.minute')}.`;
  }

  return time;
};

const selfExpiredTime = computed(() => {
  if (!props.product.self_license_expiration_date) {
    return 0;
  }

  return new Date(props.product.self_license_expiration_date).getTime();
});

const orgExpiredTime = computed(() => {
  if (!props.product.license_expiration_date) {
    return 0;
  }

  return new Date(props.product.license_expiration_date).getTime();
});

const calcExpiredTime = (date: number) => Math.floor(
  (date - new Date().getTime()) / 1000
);

const remainedTimeSeconds = computed(() => {
  if (!selfExpiredTime.value) {
    return false;
  }

  return calcExpiredTime(selfExpiredTime.value);
});

const isSoonExpire = computed(() => {
  if (!remainedTimeSeconds.value) {
    return false;
  }

  return (remainedTimeSeconds.value / 60 / 60) < 48;
});

const isOrganisationLicence = computed(
  () => props.product.license_state === LicenseState.Organization
);

const hasActiveOrgLicense = computed(
  () => isOrganisationLicence.value && orgExpiredTime.value > (new Date()).getTime()
);

const showStatistics = computed(
  () => props.product.license_state
      || props.product.product_last_start
      || props.product.self_license_expiration_date
);

const expirationDate = computed(() => {
  if (!remainedTimeSeconds.value || hasActiveOrgLicense.value) {
    return false;
  }

  if (remainedTimeSeconds.value < 0) {
    return `${t('tooltipLicenseExpired')} ${formatDate(dayjs(selfExpiredTime.value))}`;
  }

  if (isSoonExpire.value) {
    return `${t('tooltipLicense')} ${t('tooltipAfter')} ${formatTime(remainedTimeSeconds.value)}`;
  }

  return `${t('tooltipLicense')} ${formatDate(selfExpiredTime.value)}`;
});

const productSpendTime = computed(() => {
  const spendTime = props.product.product_active_duration;

  if (!spendTime) {
    return '<b>–</b>';
  }

  return spendTime < 60 ? `<b>${t('lessOneMinute')}</b>` : formatTime(spendTime, true);
});

const productLastLaunch = computed(() => {
  if (!props.product.product_last_start) {
    return '–';
  }

  return `${dayjs(props.product.product_last_start).format('DD.MM.YYYY HH:mm')}`;
});

const tooltipSpendTime = computed(() => {
  let data = `${t('tooltipSpendTime')}: ${productSpendTime.value}</br>`;
  data += `${t('tooltipLastLaunch')}: <b>${productLastLaunch.value}</b>`;

  return data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (expirationDate.value && !isAdminOrModerator.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (isSoonExpire.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(expirationDate.value), 1)
        ]))
      : _createCommentVNode("", true),
    (showStatistics.value)
      ? (_openBlock(), _createBlock(_unref(ElTooltip), {
          key: 1,
          class: "box-item",
          effect: "light",
          content: tooltipSpendTime.value,
          rawContent: "",
          placement: "bottom"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["licence-info__calendar", { '--small': expirationDate.value && !isAdminOrModerator.value }])
            }, [
              _createVNode(Calendar),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('statistics')), 1)
            ], 2)
          ]),
          _: 1
        }, 8, ["content"]))
      : _createCommentVNode("", true)
  ]))
}
}

})